import {ErrorOrigin, IResponseData, PaymentError, SuccessPayment} from "@bounce/shared/consumer/pages/payment";
import NiceModal from "@ebay/nice-modal-react";
import PaymentFailedDialog from "./components/PaymentFailedDialog";

export type {IResponseData, SuccessPayment, ErrorOrigin};
export {PaymentError};

const openPaymentFailedDialog = (
  error: string,
  errorReason?: string,
  errorExplanation?: string,
  errorOrigin?: ErrorOrigin,
  errorCode?: string
) => {
  NiceModal.show(PaymentFailedDialog, {error, errorReason, errorExplanation, errorOrigin, errorCode});
};

export {openPaymentFailedDialog};
